import React, { useState } from 'react'
import { createComponent } from 'react-fela'
import format from 'date-fns/esm/format'
import PropTypes from 'prop-types'
import DatePickerMaterial from 'design-framework/components/DatePickerMaterial/index'

import { __list, __item } from './__style'

const List = createComponent(__list, 'li')
const Item = createComponent(__item)

const DateFilter = ({ config = [], onChange = () => {}, theme }) => {
	const [isDatePickerOpen, setIsDatePickerOpen] = useState(false)

	const handleDatePickerToggle = () => {
		setIsDatePickerOpen(!isDatePickerOpen)
	}

	const handleDateChange = (startDate, endDate, name) => {
		const currentValue = {
			startDate: startDate || new Date(),
			endDate,
			name,
		}
		onChange(currentValue, true, false)
	}

	const handleDateRangeClick = (item, isChecked) => {
		if (!isChecked) {
			handleDatePickerToggle()
		} else {
			onChange(item.name, !isChecked, true)
		}
	}

	return config.map(item => {
		const { startDate, endDate } = item.values || {}

		return (
			<List key={item.name}>
				{item.name === 'range' ? (
					<DatePickerMaterial
						key={item.name}
						name={item.name}
						isDateRangePicker
						minDate={new Date()}
						format="MMM dd, yyyy"
						label={item.label}
						onDateChange={handleDateChange}
						open={isDatePickerOpen}
						onClose={handleDatePickerToggle}
						onDismiss={handleDatePickerToggle}
						style={{ marginTop: 0 }}
						renderValueByProp
						startDate={startDate}
						enddate={endDate}
						themeToUse={theme}
						inputElement={() => (
							<Item
								isActive={item.isActive}
								passThrough={['onClick']}
								onClick={() => {
									handleDateRangeClick(item, item.isActive)
								}}
							>
								{startDate
									? format(startDate, 'MMM dd, yyyy') +
									  (endDate
											? ` - ${format(
													endDate,
													'MMM dd, yyyy'
											  )}`
											: '')
									: item.label}
							</Item>
						)}
					/>
				) : (
					<Item
						isActive={item.isActive}
						passThrough={['onClick']}
						onClick={() =>
							onChange &&
							onChange(item.name, !item.isActive, true)
						}
					>
						{item.name}
					</Item>
				)}
			</List>
		)
	})
}

DateFilter.propTypes = {
	/** Configs for the price filter  */
	config: PropTypes.arrayOf(
		PropTypes.shape({
			isActive: PropTypes.bool,
			name: PropTypes.string,
			/** Min and Max Selected Values of the dateRange. Required only for name=='range' */
			values: PropTypes.shape({
				startDate: PropTypes.instanceOf(Date),
				endDate: PropTypes.instanceOf(Date),
				name: PropTypes.string,
			}),
			/** If label is not present, then name will be displayed. Required in case of name=='range' */
			label: PropTypes.string,
		})
	),
	/** Callback to call when slider values are changed. */
	onChange: PropTypes.func,
}

export default React.memo(DateFilter)
